import { Outlet, useLocation } from "react-router-dom";
import { RoleBasedSidebar } from "./RoleBasedSidebar";
import { Topbar } from "./Topbar";
import { RoutePermissionGuard } from "@/components/auth/RouteGuards";

export const PlatformLayout = () => {
  const location = useLocation();
  
  return (
    <div className="min-h-screen bg-obsidian" data-testid="platform-layout">
      <RoleBasedSidebar variant="platform" />
      <Topbar variant="platform" />
      <main className="lg:pl-[240px] min-h-[calc(100vh-64px)]">
        <div className="p-6 lg:p-8">
          <RoutePermissionGuard routePath={location.pathname}>
            <Outlet />
          </RoutePermissionGuard>
        </div>
      </main>
    </div>
  );
};

export default PlatformLayout;
